import type { Book, BookRecord } from 'types';
import { getImageUrl } from 'utils/imageHelper';
import './BookCard.css';

interface BookCardProps {
  book: Book & {
    isAvailable: boolean;
    borrowerRecord?: BookRecord;
    shelf_number?: string | null;
  };
  formatDate: (dateString: string) => string;
}

export const BookCard = ({ book, formatDate }: BookCardProps) => {
  const coverImage = getImageUrl(book.image_path);

  return (
    <div className={`book-card ${!book.isAvailable ? 'book-borrowed' : ''}`}>
      <div className="book-cover-wrapper">
        <div className="book-cover">
          {coverImage ? (
            <img
              src={coverImage}
              alt={book.title}
              className="book-cover-image"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const placeholder = target.nextElementSibling as HTMLElement;
                if (placeholder) {
                  placeholder.style.display = 'flex';
                }
              }}
            />
          ) : null}
          <div className="book-cover-placeholder" style={{ display: coverImage ? 'none' : 'flex' }}>
            <div className="placeholder-content">
              <span className="placeholder-title">{book.title}</span>
              <span className="placeholder-author">{book.author_name}</span>
            </div>
          </div>
        </div>
        <div className="book-status-badge">
          {book.isAvailable ? (
            <span className="badge-available">
              <span className="material-symbols-outlined">check_circle</span>
              Available
            </span>
          ) : (
            <span className="badge-borrowed">
              <span className="material-symbols-outlined">remove_circle</span>
              Borrowed
            </span>
          )}
        </div>
      </div>
      <div className="book-info">
        <div className="book-category-label">
          {book.category || 'General'}
        </div>
        <h3 className="book-title">{book.title}</h3>
        {book.shelf_number && (
          <p className="book-shelf">
            <span className="material-symbols-outlined">shelves</span>
            Shelf {book.shelf_number}
          </p>
        )}
        <p className="book-author">{book.author_name}</p>
        <div className="book-meta">
          {book.isbn && (
            <span className="book-isbn">ISBN: {book.isbn}</span>
          )}
        </div>
      </div>
      {!book.isAvailable && book.borrowerRecord && (
        <div className="borrower-details">
          <p>
            <strong>Borrowed by:</strong> {book.borrowerRecord.borrower_name}
          </p>
          {book.borrowerRecord.contact_info && (
            <p>
              <strong>Contact:</strong> {book.borrowerRecord.contact_info}
            </p>
          )}
          <p>
            <strong>Borrowed on:</strong> {formatDate(book.borrowerRecord.borrowed_date)}
          </p>
        </div>
      )}
    </div>
  );
};
